import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useWMS2040_R01Store, { defaultWMS2040_R01Filter } from "./Store_WMS2040_R01";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { SearchSpacer } from "src/components/common/common";
import { CustomerResponseDto } from "src/dtos/customer/customerResponseDto";
import { getCustomerList } from "src/apis/customerApi";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {}

export const SearchSection_WMS2040_R01 = ({}: Props) => {
    const {
        WMS2040_R01Filter, 
        setWMS2040_R01Filter
    } = useWMS2040_R01Store();

    const {
        brandCdList,         //  브랜드 공통코드
        compCdList,          //  사업장 공통코드
		itemGroupList,
        warehouseCdList,     //  창고 공통코드
        itemStatusList,      //  품목등급 공통코드
        majorCodeList,        //  물류센터 공통코드
        wmsCdList
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleItemFoucsId = 'itemCd_search';
	const handlePartnerFoucsId = 'partnerCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: WMS2040_R01Filter.itemCd || '',
				itemNm: WMS2040_R01Filter.itemNm || '',
			}),
		},
		{
			fieldName: 'partnerCd',
			category: '거래처',
			focusId: handlePartnerFoucsId,
			responseMapping: {
				customCd: 'partnerCd',
				customNm: 'partnerNm',
			},
			extraFilter: () => ({
				partnerCd: WMS2040_R01Filter.partnerCd || '',
				partnerNm: WMS2040_R01Filter.partnerNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS2040_R01Filter,
		setEditData: setWMS2040_R01Filter,
		defaultData: defaultWMS2040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'WMS2040_R01_search'
	});

    return (
        <div className="w-full">
            <SearchSectionDoubleForm>
                {/* 첫 번째 행 */}
                <SearchDropDownForm<CompanyDto>
                    label="사업장"
                    value={WMS2040_R01Filter.compCd || 'all'}
                    optionList={compCdList}
                    onChangeValue={v => setWMS2040_R01Filter({ compCd: v === 'all' ? '' : v })}
                />
                
                <SearchDateRangeForm
                label="수불연월"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={WMS2040_R01Filter.txDt}
                setDateRange={v => setWMS2040_R01Filter({ txDt: v })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
                
                <SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={WMS2040_R01Filter.logicCenter || 'all'}
                    optionList={wmsCdList}
                    onChangeValue={v => setWMS2040_R01Filter({ logicCenter: v === 'all' ? '' : v })}
                />
                
                <SearchDropDownForm<WareHouseDto>
                    label="창고코드"
                    value={WMS2040_R01Filter.warehouseCd || 'all'}
                    optionList={warehouseCdList}
                    onChangeValue={v => setWMS2040_R01Filter({ warehouseCd: v === 'all' ? '' : v })}
                />
                
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={WMS2040_R01Filter.brandCd || 'all'}
                    optionList={brandCdList}
                    onChangeValue={v => setWMS2040_R01Filter({ brandCd: v === 'all' ? '' : v })}
                />

                {/* 두 번째 행 */}
                <SearchCodeModalForm
                    label="거래처"
                    value={WMS2040_R01Filter.partnerCd}
                    valueLabel={WMS2040_R01Filter.partnerNm || ''}
                    handleFoucsId={handlePartnerFoucsId}
                    onChange={getFieldHandlers('partnerCd').onChange}
                    onDoubleClick={getFieldHandlers('partnerCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('partnerCd').onEnterKeyDown}
                />
                

                
                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={WMS2040_R01Filter.itemGroup || 'all'}
                    optionList={itemGroupList}
                    onChangeValue={v => setWMS2040_R01Filter({ itemGroup: v === 'all' ? '' : v })}
                />
                <SearchCodeModalForm
                    label="품목코드"
                    value={WMS2040_R01Filter.itemCd}
                    valueLabel={WMS2040_R01Filter.itemNm || ''}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                {/* 재고0 포함 체크박스 */}
                <div className="flex items-center gap-2 px-7 py-1">
                <label htmlFor="includeZeroStock" className="text-s cursor-pointer select-none">
                        재고0 포함
                    </label>
                    <input
                        type="checkbox"
                        id="includeZeroStock"
                        checked={WMS2040_R01Filter.includeZeroStock ?? false}
                        onChange={(e) => setWMS2040_R01Filter({ includeZeroStock: e.target.checked })}
                        className="cursor-pointer"
                    />
                </div>
            </SearchSectionDoubleForm>
        </div>
    );
};
